const Background = () => import('views/bg/Background')
// ********************************************************************************************************************
// 稿件后台管理
const VideoPost = () => import('views/bg/post/VideoPost')
const ImagePost = () => import('views/bg/post/ImagePost')

export default {
  path: '/bg/post',
  redirect: '/bg',
  name: 'Post',
  title: '我的稿件',
  icon: 'el-icon-film',
  component: Background,
  meta: { needAuth: true, roles: ['tnb_user'] },
  children: [
    {
      path: '/bg/post/video',
      name: 'VideoPost',
      title: '视频稿件',
      icon: 'el-icon-film',
      component: VideoPost,
      meta: { needAuth: true, roles: ['tnb_user'] }
    },
    {
      path: '/bg/post/image',
      name: 'ImagePost',
      title: '相册稿件',
      icon: 'el-icon-film',
      component: ImagePost,
      meta: { needAuth: true, roles: ['tnb_user'] }
    }
  ]
}
